import IntegratedIframe from 'components/iframe/IntegratedIframe';

export const RequestSupportAdd = ({ dataSupport }) => {
    const url = `${dataSupport.url}${dataSupport.api_add_helpdesk_odoo}/${dataSupport.elf}`;
    return (
        <div className="">
            <IntegratedIframe src={url} width={'100%'} />
        </div>
    );
};
